import React, { useEffect, useState } from 'react';
import { Link, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Slider from 'react-slick';
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';
import CustomArrow from "../../react-only-components/CarouselArrow";
import { windowService } from '../../utils/window.utils';
import appendDots from '../../react-only-components/CustomCarouselDots/appendDots';
import CarouselSlide from './components/carouselSlide';
import { SpecialOffersModel, SpecialOffersSlideModel } from './models/cardCarousel.model';
import { TSpecialOffersProps } from './types/cardCarousel.types';
import CarouselDots from "../../react-only-components/CarouselDots";
import './styles.scss'

const CardCarousel = (props: TSpecialOffersProps): JSX.Element => {
  const isEE = props?.sitecoreContext?.pageEditing;
  const model = new SpecialOffersModel(props);
  const cardsCount = (model?.items || []).length;
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const [screenWidth, setScreenWidth] = useState(1680);
  const [activeCardIndex, updateActiveIndex] = useState(0);
  const [isClickedOnArrow, setIsClickedOnArrow] = useState(false);
  const containerPaddingLeft = 32;
  const largeImageWidth = isDesktop ? 664 : 300;
  const smallImageWidth = isDesktop ? 392 : 300;

  const totalElementsWidth =
    model?.items?.reduce((sumWidths: number, curr: SpecialOffersSlideModel) => {
      if (curr?.type?.value === 'offerCardWide') {
        sumWidths += largeImageWidth;
      } else {
        sumWidths += smallImageWidth;
      }

      return sumWidths;
    }, 0) + containerPaddingLeft;
  const shouldInstanceCarousel = totalElementsWidth > screenWidth;

  const arrowButtonClick = (): void => {
    setIsClickedOnArrow(true);
  };

  const settings = {
    infinite: shouldInstanceCarousel,
    dots: shouldInstanceCarousel,
    arrows: !isEE && shouldInstanceCarousel,
    variableWidth: true,
    speed: 500,
    slidesToScroll: 1,
    nextArrow: <CustomArrow direction="next" onClick={arrowButtonClick} />,
    prevArrow: <CustomArrow direction="previous" onClick={arrowButtonClick} />,
    customPaging: () => <CarouselDots />,
    afterChange: (index): void => {
      updateActiveIndex(index);
    },
    appendDots: (dots) => appendDots({ dots, cardsCount, activeCardIndex, showCustomDots: true }),
  };

  useEffect(() => {
    setScreenWidth(Math.min(windowService()?.innerWidth, 1680));
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  useEffect(() => {
    if (!isClickedOnArrow) {
      return;
    }

    setIsClickedOnArrow(false);
  }, [activeCardIndex]);


  return (
    <div className="card-carousel special-offers-wrapper">
      <div className="special-offers">
        <div className='card-carousel-heading'>
          <Text
            tag="p"
            field={model.eyebrow}
            className="hero-banner__eyebrow card-carousel-heading__eyebrow"
          />
          <Text
            tag="h2"
            field={model.title}
            className=" special-offers__title"
          />
          <RichText
            tag="div"
            field={model.subtitle}
            className="special-offers__subtitle card-carousel-heading__subtitle"
          />
          {(isEE || (model.link?.value?.text && model.link?.value?.href)) && (
            <div className={'cta cta-primary-offwhitered card-carousel-heading__cta'}>
              <Link field={model?.link ?? {}} className='card-carousel-heading__cta-link' />
              <span className="link-with-arrow link-with-arrow--text">
                <pfe-icon icon="cnh-arrow-forward" size={'24'} color={'complement'} />
              </span>
            </div>
          )}
        </div>
        <Slider {...settings} className='special-offers__carousel'>
          {model?.items?.map((item, index) => (
            <div key={index} className="special-offers__slide">
              <CarouselSlide
                model={item}
                isEE={isEE}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default withSitecoreContext()(CardCarousel);
